<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 11L9.5 8L6.5 5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>